import script from "./edit-property-listing-room.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-property-listing-room.vue?vue&type=script&setup=true&lang=ts"

import "./edit-property-listing-room.vue?vue&type=style&index=0&id=5a1d554d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a1d554d"]])

export default __exports__